import React, { Component } from 'react';
import API from '../../utils/API';
import SaveBar from './components/SaveBar';

const PRESETS = [
	{ label: 'Airport Transfers',    icon: 'las la-shuttle-van' },
	{ label: 'Audio Visual (A/V)',   icon: 'las la-video' },
	{ label: 'Décor & Design',       icon: 'las la-palette' },
	{ label: 'Entertainment',        icon: 'las la-music' },
	{ label: 'Event Photography',    icon: 'las la-camera' },
	{ label: 'Floral Services',      icon: 'las la-seedling' },
	{ label: 'Guest Speakers',       icon: 'las la-microphone' },
	{ label: 'Off-site Activities',  icon: 'las la-hiking' },
	{ label: 'Production Services',  icon: 'las la-film' },
	{ label: 'Security Services',    icon: 'las la-user-shield' },
	{ label: 'Shuttle Services',     icon: 'las la-bus' },
	{ label: 'Signage & Branding',   icon: 'las la-sign' },
	{ label: 'Spa Services',         icon: 'las la-spa' },
	{ label: 'Team Building',        icon: 'las la-puzzle-piece' },
	{ label: 'VIP Services',         icon: 'las la-star' },
	{ label: 'WiFi/Internet Upgrades', icon: 'las la-wifi' }
];
const PRESET_LABELS = PRESETS.map((p) => p.label);

class AdditionalServices extends Component {
	constructor(props) {
		super(props);
		this.state = {
			selected: props.request?.additionalServices || [],
			draft: '',
			editing: false,
			saving: false
		};
	}

	toggle = (s) => {
		this.setState((st) => ({
			selected: st.selected.includes(s) ? st.selected.filter((x) => x !== s) : [...st.selected, s],
			editing: true
		}));
	};

	addCustom = () => {
		const v = this.state.draft.trim();
		if (!v || this.state.selected.includes(v)) return;
		this.setState((s) => ({ selected: [...s.selected, v], draft: '', editing: true }));
	};

	remove = (s) => {
		this.setState((st) => ({
			selected: st.selected.filter((x) => x !== s),
			editing: true
		}));
	};

	save = async () => {
		this.setState({ saving: true });
		try {
			await API().patch(
				`Organizations/${this.props.orgId}/proposal-requests/${this.props.requestId}`,
				{ additionalServices: this.state.selected }
			);
			this.setState({ editing: false, saving: false });
			this.props.refreshSectionCounts && this.props.refreshSectionCounts();
		} catch (e) {
			console.error('Error saving services:', e);
			this.setState({ saving: false });
		}
	};

	cancel = () => {
		this.setState({
			selected: this.props.request?.additionalServices || [],
			draft: '',
			editing: false
		});
	};

	render() {
		const { selected, draft, editing, saving } = this.state;
		const { request } = this.props;
		const custom = selected.filter((s) => !PRESET_LABELS.includes(s));

		return (
			<>
				<h2 className="pr-subsection-title">Services Needed On-Site</h2>
				<p className="pr-field-sublabel">Pick anything the venue should plan for or help coordinate.</p>

				<div className="pr-option-grid" style={{ marginBottom: 28 }}>
					{PRESETS.map((p) => {
						const on = selected.includes(p.label);
						return (
							<button
								key={p.label}
								type="button"
								className={`pr-option-card ${on ? 'selected' : ''}`}
								onClick={() => this.toggle(p.label)}
							>
								<i className={p.icon} />
								<span>{p.label}</span>
							</button>
						);
					})}
				</div>

				<h2 className="pr-subsection-title">Custom Services</h2>

				<div className="pr-field-group">
					<label className="pr-field-label">Add a service not listed above</label>
					<div style={{ display: 'flex', gap: 12 }}>
						<input
							className="pr-text-input"
							type="text"
							value={draft}
							onChange={(e) => this.setState({ draft: e.target.value })}
							onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); this.addCustom(); } }}
							placeholder="Type a service and press Enter"
						/>
						<button
							type="button"
							className="pr-btn-ghost"
							onClick={this.addCustom}
							disabled={!draft.trim()}
						>
							<i className="las la-plus" />
							Add
						</button>
					</div>
				</div>

				{custom.length > 0 && (
					<div style={{ marginBottom: 12 }}>
						{custom.map((s) => (
							<div key={s} className="pr-chip-row">
								<span>{s}</span>
								<button type="button" className="pr-chip-remove" onClick={() => this.remove(s)}>
									<i className="las la-times" />
								</button>
							</div>
						))}
					</div>
				)}

				<SaveBar
					editing={editing}
					saving={saving}
					onSave={this.save}
					onCancel={this.cancel}
					updatedAt={request?.updatedAt}
				/>
			</>
		);
	}
}

export default AdditionalServices;
